import { Injectable } from '@angular/core';
import { UserSession } from '../../domain/user-session';
import { Carrito } from '../../domain/carrito';
import { AppService } from '../../app.service';
import { GLOBAL } from '../../global';
import { ShoppingCartService } from '../shopping-cart.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userSession: UserSession;

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  constructor(
    private shoppingCartService: ShoppingCartService
  ) { }

  /**
   * Verifica si un usuario se ha autenticado, y tiene un token válido.
   * 
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  isAuthenticate(): boolean {
    if (localStorage.getItem(GLOBAL.LOCALSTORAGE_SIGAMOSCARTTOKEN) !== null
        && localStorage.getItem(GLOBAL.LOCALSTORAGE_SIGAMOSCARTTOKEN) !== undefined) {
      let payload = this.getToken().split('.')[1];
      let payloadDecoded = JSON.parse(atob(payload));
      const expiredAt: number = payloadDecoded.exp * 1000;
      let now: number = (new Date()).getTime();
      
      if (expiredAt <= now) {
        this.logout();
        return false;
      } else {
        return true;
      }
    } else {
      this.logout();
      return false;
    }    
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  login(jwt: string) {
    localStorage.setItem(GLOBAL.LOCALSTORAGE_SIGAMOSCARTTOKEN, jwt);    
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06
   */
  logout() {
    this.userSession = null;

    const cartListNoLogin: Carrito = JSON.parse(localStorage.getItem(GLOBAL.LOCALSTORAGE_CARTLISTNOLOGIN));

    if (cartListNoLogin
      && this.shoppingCartService.carrito.listSicaDetalleCarrito.length === 0) {
      this.shoppingCartService.carrito.carrId = null;
      this.shoppingCartService.carrito.tercId_SicaTercero = null;
      this.shoppingCartService.carrito.costoEnvio = null;
      this.shoppingCartService.carrito.estado = null;
      this.shoppingCartService.carrito.fechaCreacion = null;
      this.shoppingCartService.carrito.fechaInicio = null;
      this.shoppingCartService.carrito.fechaModificacion = null;
      this.shoppingCartService.carrito.totalItems = 0;
      this.shoppingCartService.carrito.usuarioCreador = null;
      this.shoppingCartService.carrito.usuarioModificador = null;
      this.shoppingCartService.carrito.valorIva = null;
      this.shoppingCartService.carrito.valorTotal = 0;
      this.shoppingCartService.carrito.listSicaDetalleCarrito = [];
      this.shoppingCartService.setCarritoNoLogin(this.shoppingCartService.carrito);
    }

    const cartList: Carrito = JSON.parse(localStorage.getItem(GLOBAL.LOCALSTORAGE_CARTLIST));

    // if (!cartList
    //   && !cartListNoLogin) {
    //   this.shoppingCartService.carrito.carrId = null;
    //   this.shoppingCartService.carrito.tercId_SicaTercero = null;
    //   this.shoppingCartService.carrito.costoEnvio = null;
    //   this.shoppingCartService.carrito.estado = null;
    //   this.shoppingCartService.carrito.fechaCreacion = null;
    //   this.shoppingCartService.carrito.fechaInicio = null;
    //   this.shoppingCartService.carrito.fechaModificacion = null;
    //   this.shoppingCartService.carrito.totalItems = 0;
    //   this.shoppingCartService.carrito.usuarioCreador = null;
    //   this.shoppingCartService.carrito.usuarioModificador = null;
    //   this.shoppingCartService.carrito.valorIva = null;
    //   this.shoppingCartService.carrito.valorTotal = 0;
    //   this.shoppingCartService.carrito.listSicaDetalleCarrito = [];
    // }

    localStorage.removeItem(GLOBAL.LOCALSTORAGE_SIGAMOSCARTTOKEN);
    localStorage.removeItem(GLOBAL.LOCALSTORAGE_CARTLIST);
    localStorage.removeItem(GLOBAL.LOCALSTORAGE_EMAILTMP);
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06   
   */
  setUser(payloadDecoded) {
    if (payloadDecoded === null || payloadDecoded === undefined) {
      payloadDecoded = new UserSession();
    }

    if (this.userSession === null || this.userSession === undefined) {
      this.userSession = new UserSession();
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.jti =  +payloadDecoded.jti;
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.sub = payloadDecoded.sub;
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.iss = payloadDecoded.iss;
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.role = payloadDecoded.role;
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.iat = payloadDecoded.iat;
    }

    if (payloadDecoded !== null && payloadDecoded !== undefined) {
      this.userSession.exp = payloadDecoded.exp;
    }    
  }  

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-07
   */
  getToken() {
    return localStorage.getItem(GLOBAL.LOCALSTORAGE_SIGAMOSCARTTOKEN);
  }

  /**
   * @author Frank Edward Daza González
   * @version 2018-11-06   
   */
  getUser() {  
    if (this.isAuthenticate()) {
      let payload = this.getToken().split('.')[1];
      let payloadDecoded = JSON.parse(this.b64DecodeUnicode(payload));
      this.setUser(payloadDecoded);
      return this.userSession;
    } else {
      this.logout();
      return null;
    } 
  }

  b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

  /**
   * Retorna el rol del usuario que se encuentra en el JWT.
   * 
   * @author Frank Edward Daza González
   * @version 2018-12-03
   */
  getRol(): string {
    if (this.userSession) {
      return this.userSession.role;
    }

    const userSession: UserSession = this.getUser();
      
    if (userSession) {
      return userSession.role;
    }

    return "";
  }

}
